angular.module('bmsApp.directives')
	.directive('fadeMessage', function() {
		return {
			restrict: 'E',
			require: [],
			scope: {
				show: '=?',
				type: '@',
				delay: '@',
				toggle: '&'
			},
			transclude: true,
			replace: true,
			controller: function($scope, $timeout){
				$scope.fade = false;
				$scope.$watch('show', function(show){
					if (show) {
						$timeout(function(){
							$scope.fade = true;
							$timeout(function(){
								$scope.fade = false;
								$scope.show = false;
							}, 250);
						}, $scope.delay);
					}
				});
			},
			link: function($scope, iElement, iAttrs) {
				if (angular.isUndefined($scope.type)) {
					$scope.type = 'info';
				}
				if (angular.isUndefined($scope.delay)) {
					$scope.delay = 5000;
				}
			},
			template: '<div class="alert alert-{{ type }}" ng-class="{fade: fade}" ng-show="show"><ng-transclude></ng-transclude></div>'
		}
});
